import React from 'react';
import {  cloneDeep, get, findIndex, isUndefined, noop, forEach, find, isEmpty, size } from 'lodash';

// React view component to render
import {  addEditAllergies as AddEditAllergiesView  } from 'ui/views/widgets/addEditAllergies';

/**
 * @type { class }
 * @desc A React container/smart component to render a React presentational/dumb component ( view ).
 * @example
 * import {  AddEditAllergies  } from 'ui/containers/AddEditAllergies';
 *
 * // render
 * <AddEditAllergies propName='propValue'/>
 */
export class AddEditAllergies extends React.Component {

	/**
	 * @param { object } props - props
	 */
	constructor( props ) {
		super( props );

		const previouslySelectedAllergies = [];
		const isAllergiesNotAtVerified= props.finalProp.isAllergiesNotAtVerified!=undefined?props.finalProp.isAllergiesNotAtVerified:false ;
		const isNoKnownDrugAllergies= props.finalProp.isNoKnownDrugAllergies!=undefined? props.finalProp.isNoKnownDrugAllergies:false ;
		const isNoKnownHealthConditions= props.finalProp.isNoKnownHealthConditions!=undefined? props.finalProp.isNoKnownHealthConditions:false ;
		if( ! isEmpty( get( this.props, 'items', [] ) ) ) {
			forEach( this.props.items, ( allergy ) => {
				// allergy.selected = true;	previouslySelectedAllergies.push( allergy );

				if( ( false === isAllergiesNotAtVerified && false === isNoKnownDrugAllergies) || (false === isNoKnownHealthConditions))
				 { allergy.selected = true;	previouslySelectedAllergies.push( allergy );}
			} );
		}
		this.state = {
			previouslySelectedAllergies: previouslySelectedAllergies,
			currentSelectedAllergies: [],
			note: '',
			isAllergiesNotAtVerified: isAllergiesNotAtVerified,
			isNoKnownDrugAllergies: isNoKnownDrugAllergies,
			isNoKnownHealthConditions: isNoKnownHealthConditions,
			isNotVerifiedDataSelected: 0 === size( get( this.props, 'items', [] ) ),
			isNoDataSelected: 0 === size( get( this.props, 'items', [] ) )
		};

		// bind methods to instance
		this.handleNoteUpdate = this.handleNoteUpdate.bind( this );
		this.handleCurrentSelection = this.handleCurrentSelection.bind( this );
		this.handleAllergySelection = this.handleAllergySelection.bind( this );
		this.handlePreSelectedListSelection = this.handlePreSelectedListSelection.bind( this );
		this.clearCheckboxSelectionForAllergies = this.clearCheckboxSelectionForAllergies.bind( this );
		this.updateHealthInfo = this.updateHealthInfo.bind( this );
		this.handleNoDataSelection = this.handleNoDataSelection.bind( this );
		this.handleNotVerifiedDataSelection = this.handleNotVerifiedDataSelection.bind( this );
		this.updateHealthInfo();
	}
	componentDidMount() {
		this.updateHealthInfo();
	}

	// update State and update state of the parent also to maintain the array of IDs selected
	// updateState( {
	// 	memberAllergies = this.state.memberAllergies,
	// 	pickedAllergiesIds = this.state.pickedAllergiesIds,
	// 	selectedCommonAllergies = this.state.selectedCommonAllergies,
	// 	note = this.state.note,
	// } ) {

	// 	// should update the parent or not
	// 	const shouldUpdate = ( this.state.pickedAllergiesIds !== pickedAllergiesIds ) || ( this.state.note !== note );

	// 	this.setState( {
	// 		memberAllergies: memberAllergies,
	// 		pickedAllergiesIds: pickedAllergiesIds,
	// 		selectedCommonAllergies: selectedCommonAllergies,
	// 		note: note,
    //     }, shouldUpdate ? () => this.props.onUpdate( { selectedAllergies: pickedAllergiesIds, note: note } ) : null );
    
	// }

	// Handler for when user check/unCheck the Member Allergies
	// checkMarkHandler( {  item, isChecked  } ) {
	// 	log.debug( 'MemberAllergiesInfo.checkMarkHandler()' );

	// 	let allergies = cloneDeep( this.state.pickedAllergiesIds );

	// 	const memberAllergies = cloneDeep( this.state.memberAllergies );

	// 	map( memberAllergies, ( allergy ) => {
	// 		allergy.id === item ? ( allergy.selected = isChecked ) : null;
	// 	} );

	// 	if ( isChecked ) {
	// 		allergies.push( item );

	// 		this.updateState( {
	// 			pickedAllergiesIds: allergies,
	// 			memberAllergies: memberAllergies,
	// 		} );

	// 	} else {
	// 		allergies = allergies.filter( ( allergy ) => allergy !== item );

	// 		this.updateState( {
	// 			pickedAllergiesIds: allergies,
	// 			memberAllergies: memberAllergies,
	// 		} );

	// 	}
	// }

	// Handler for when user check/unCheck the options from Common Allergies Dropdown
	// onSelectCommonAllergies( { selected, options  } ) {
	// 	log.debug( 'MemberAllergiesInfo.onSelectCommonAllergies()' );

	// 	const selectedCommonAllergies = filter( options, function ( option ) {
	// 		return includes( selected, option.name );
	// 	} );

	// 	const selectedIds = [];

	// 	forEach( selected, selectedOption => {
	// 		const findDrugObject = find( options, { name: selectedOption } );
	// 		selectedIds.push( findDrugObject.value );
	// 	} );

	// 	this.updateState( {
	// 		pickedAllergiesIds: selectedIds,

	// 		// pickedAllergiesIds: [ ...selected ],
	// 		selectedCommonAllergies: selectedCommonAllergies,
	// 	} );

	// }
  
	handleNotVerifiedDataSelection( value ) {
		log.debug( 'MemberAllergiesInfo.handleNotVerifiedDataSelection()' );
		let isAllergiesNotAtVerified= false;

		// const isNotVerifiedDataSelected = ! cloneDeep( this.state.isNotVerifiedDataSelected );
		if( 'AllergiesCondition' == value ) {
			isAllergiesNotAtVerified =! cloneDeep( this.state.isAllergiesNotAtVerified );
		}

		if( isAllergiesNotAtVerified ) {
            
			this.setState( {
				isAllergiesNotAtVerified: isAllergiesNotAtVerified,
				isNoKnownDrugAllergies: false,
				isNoKnownHealthConditions: false,
				//previouslySelectedAllergies: [],
				//currentSelectedAllergies: [],
				// eslint-disable-next-line no-dupe-keys
				note: '',
			}, ()  => {
	
				this.updateHealthInfo();
	
			} );

		} else {

			this.setState( {
				isAllergiesNotAtVerified: isAllergiesNotAtVerified,
			},()=> { this.updateHealthInfo(); } );
		}
	}
	clearCheckboxSelectionForAllergies( isAllergySelected = false ) {
		if ( isAllergySelected ) {
			this.setState( {
				isNoKnownDrugAllergies: false,
				isAllergiesNotAtVerified: false,
			} );
		} else {
			this.setState( {
				isNoKnownHealthConditions: false
			} );
		}
	}
	handleNoDataSelection( value ) {
		log.debug( 'MemberAllergiesInfo.handleNoDataSelection()' );

		// const isNoDataSelected = ! cloneDeep( this.state.isNoDataSelected );
	   // const isNoKnownDrugAllergies= ! cloneDeep( this.state.isNoKnownDrugAllergies );
	   let isNoKnownDrugAllergies=false;
	   let isNoKnownHealthConditions =false;
		if( 'AllergiesCondition' ==value ) { isNoKnownDrugAllergies =! cloneDeep( this.state.isNoKnownDrugAllergies ); }else{
			isNoKnownHealthConditions =!  cloneDeep( this.state.isNoKnownHealthConditions );
	   }

		if( isNoKnownDrugAllergies || isNoKnownHealthConditions  ) {

			this.setState( {
				// isNoDataSelected: isNoDataSelected,

				isNoKnownDrugAllergies: isNoKnownDrugAllergies,
				isNoKnownHealthConditions: isNoKnownHealthConditions,
				isAllergiesNotAtVerified: false,
			//	previouslySelectedAllergies: [],
			//	currentSelectedAllergies: [],
				note: '',
			}, ()  => {
	
				this.updateHealthInfo();
	
			} );

		} else {

			this.setState( {

			//	isNoDataSelected: isNoDataSelected
			isNoKnownDrugAllergies: isNoKnownDrugAllergies,
			isNoKnownHealthConditions: isNoKnownHealthConditions
			},()=> { this.updateHealthInfo(); } );
		}
	}

	handleAllergySelection( { selected, options } ) {
		log.debug( 'MemberAllergiesInfo.handleAllergySelection()' );
		const currentSelectedAllergies = cloneDeep( this.state.currentSelectedAllergies );
		forEach( selected, selectedName => {

			// get the selection object
			const selectionObj = find( options, { [ `${this.props.selectionCriteria}` ]: selectedName } );

			// find if the value id present
			const checkIfValueIsPresent = 0 !== size( currentSelectedAllergies ) ? find( this.state.currentSelectedAllergies, { value: selectionObj.value } ): undefined;

			if( isUndefined( checkIfValueIsPresent ) ) {
				selectionObj.selected = true;
				currentSelectedAllergies.push( selectionObj );
			}
		} );
		this.setState( { currentSelectedAllergies }, () => {

			this.updateHealthInfo();

		} );
	}


	handlePreSelectedListSelection( { item } ) {
		log.debug( 'MemberAllergiesInfo.handlePreSelectedListSelection()' );
		const previouslySelectedAllergies = get( this.state, 'previouslySelectedAllergies', [] );
		const allergyIndex = findIndex( previouslySelectedAllergies, { id: item.id } );
		previouslySelectedAllergies[ allergyIndex ].selected = ! previouslySelectedAllergies[ allergyIndex ].selected;
		this.setState( { previouslySelectedAllergies }, () => {
			
			this.updateHealthInfo();

		} );
	}

	handleCurrentSelection( { item } ) {
		log.debug( 'MemberAllergiesInfo.handleCurrentSelection()' );
		const currentSelectedAllergies = get( this.state, 'currentSelectedAllergies', [] );
		// get the index of the allergu/health condition
		const allergyIndex = findIndex( currentSelectedAllergies, { [ `${this.props.selectionCriteria}` ]: item.name } );
		
		currentSelectedAllergies[ allergyIndex ].selected = ! currentSelectedAllergies[ allergyIndex ].selected;
		this.setState( { currentSelectedAllergies }, () => {

			this.updateHealthInfo();
		} );
	}

	// handle on submit click
	updateHealthInfo() {
		log.debug( 'MemberAllergiesInfo.saveHandler()' );
		let selectedItems = [];

		forEach( [ ...this.state.previouslySelectedAllergies, ...this.state.currentSelectedAllergies ], allery => {
			if( allery.selected ) {
				selectedItems.push( allery.id || allery.value );
				// if( false ===this.state.isNoKnownDrugAllergies && false ===this.state.isAllergiesNotAtVerified ) {
				// selectedItems.push( allery.id || allery.value );
				// }
				
			}
		} );

		// if( 0 === size( selectedItems ) || get( this.state, 'isNoDataSelected', false ) ) {
		// 	selectedItems = [ 'none' ];
		// }

		// if( 0 === size( selectedItems ) || get( this.state, 'isNotVerifiedDataSelected', false ) ) {
		// 	selectedItems = [ 'none' ];
		// }

		// if ( 'AllergiesCondition'===this.props.titlehealth ) { 
		// 	if( 0 === size( selectedItems ) || get( this.state, 'isNoKnownDrugAllergies', false ) ) {
		// 		selectedItems = [ 'none' ];
		// 	}
		// 	if( 0 === size( selectedItems ) || get( this.state, 'isAllergiesNotAtVerified', false ) ) {
		// 		selectedItems = [ 'none' ];
		// 	}
		// } else {
		// 	if( 0 === size( selectedItems ) || get( this.state, 'isNoKnownHealthConditions', false ) ) {
		// 		selectedItems = [ 'none' ];
		// 	}
		// }

'AllergiesCondition'===this.props.titlehealth?this.props.onUpdate( { selectedItems, note: this.state.note, isNoKnownDrugAllergies: this.state.isNoKnownDrugAllergies, isAllergiesNotAtVerified: this.state.isAllergiesNotAtVerified } ): this.props.onUpdate( { selectedItems, note: this.state.note, isNoKnownHealthConditions: this.state.isNoKnownHealthConditions } ) ;
		
	}

	// handle note value change
	handleNoteUpdate( event ) {
		log.debug( 'MemberAllergiesInfo.handleNoteUpdate()' );
		this.setState( {  note: event.target.value  }, () => {
			this.updateHealthInfo();
		} );
	}

	/* ********************************************** */

	/**
	 * @desc Render a React view component
	 */
	render() {
		return (
			<AddEditAllergiesView
				{  ...this.props  }
				onNoteUpdate={ this.handleNoteUpdate }
				updatePreSelectedList={ this.handlePreSelectedListSelection }
				clearCheckboxSelectionForAllergies={ this.clearCheckboxSelectionForAllergies }
				onAllergySelection={ this.handleAllergySelection }
				updateCurrentSelectedList= { this.handleCurrentSelection }
				onNoDataSelection = { this.handleNoDataSelection }
				onNotVerifiedDataSelection = { this.handleNotVerifiedDataSelection }
				previouslySelectedAllergies = { this.state.previouslySelectedAllergies }
				currentSelectedAllergies= { this.state.currentSelectedAllergies }
				isNoDataSelected={ this.state.isNoDataSelected }
				isNotVerifiedDataSelected={this.state.isNotVerifiedDataSelected}
				note={ this.state.note }
				dataProps= {this.props }
				isAllergiesNotAtVerified= { this.state.isAllergiesNotAtVerified }
				isNoKnownDrugAllergies= { this.state.isNoKnownDrugAllergies }
				isNoKnownHealthConditions= { this.state.isNoKnownHealthConditions }
				isBlankDivRquied ={this.props.isBlankDivRquied}
				
			/>
		);
	}
 }

// set display name
AddEditAllergies.displayName = 'AddEditAllergies';

// set default props
AddEditAllergies.defaultProps = {
	notePlaceHolder: {},
	allergies: [],
	addEditMemberHealthConfig: {
		fields: [],
		title: {},
	},
	selectionCriteria: 'value',
	showTitleIcon: false,
	isBlankDivRquied : true,
	template: 'default',
    onUpdate: noop // functions that will run if allergies or items got updated
 };

// prop types
AddEditAllergies.propTypes = {};
